import { render, staticRenderFns } from "./InstantTrade.vue?vue&type=template&id=03166569"
import script from "./InstantTrade.vue?vue&type=script&lang=js"
export * from "./InstantTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports